import ApiService from '@/services/api.js'
import { saveProject, saveBoard } from '@/store/utils.js'

/**
 * @param   {Store}        context
 * @param   {Store.commit} context.commit
 * @param   {object}       payload
 *
 * @returns {object}
 */
const addProject = async ({ commit }, payload) => {
  const response = await ApiService.createProject(
    payload.name,
    payload.groupId,
    payload.seasonId
  )
  const project = response.data

  commit('addProject', project)

  return project
}

/**
 * @param   {Store}        context
 * @param   {Store.commit} context.commit
 * @param   {object}       payload
 *
 * @returns {object}
 */
const updateProject = async ({ commit }, payload) => {
  const response = await ApiService.updateProject(
    payload.projectId,
    payload.visibleToSales
  )
  const project = response.data

  commit('updateProject', project)

  return project
}

/**
 * @param {Store}        context
 * @param {Store.commit} context.commit
 * @param {number}       projectId
 */
const deleteProject = async ({ commit }, projectId) => {
  await ApiService.deleteProject(projectId)

  commit('deleteProject', projectId)
}

/**
 * @param   {Store}        context
 * @param   {Store.commit} context.commit
 * @param   {object}       payload
 *
 * @returns {object[]}
 */
const fetchProjects = async ({ commit }, payload) => {
  const response = await ApiService.fetchProjects(
    payload.groupId,
    payload.seasonId
  )
  const projects = response.data

  projects.reverse()

  commit('setProjects', projects)

  return projects
}

/**
 * @param   {Store}         context
 * @param   {Store.commit}  context.commit
 * @param   {Store.getters} context.getters
 * @param   {object}        payload
 *
 * @returns {object}
 */
const fetchProject = async ({ commit, getters }, payload) => {
  const projectResponse = await ApiService.fetchProject(payload.projectId)
  const project = projectResponse.data

  saveProject({ commit, getters }, project)

  const boardsResponse = await ApiService.fetchBoards(payload.projectId)

  boardsResponse.data.forEach(board => {
    saveBoard({ commit, getters }, board)
  })

  return project
}

/**
 * @type {object}
 */
const actions = {
  addProject,
  updateProject,
  deleteProject,
  fetchProjects,
  fetchProject
}

export default actions
